// extracted by mini-css-extract-plugin
export default {"container":"YaBottomContainerDOM_container__0O96F","android":"YaBottomContainerDOM_android__wEOv1"};